import React from 'react';
import {
  Box, Checkbox, costFormater, PriceInput, Text,
} from '@common-fe/common-fe';

import { DEFAULT_EMPTY_CHARACTER } from '@/common/constants';

import FraudThresholdFieldLabel from './FraudThresholdFieldLabel';

interface Props {
  title: string;
  desc: string;
  testId: string;
  disabled?: boolean;
  viewMode?: boolean;
  checked: boolean;
  amount: string;
  error?: string;
  onCheckedChange: (value: boolean) => void;
  onAmountChange: (value: string) => void;
}

const FraudThresholdField: React.FC<Props> = ({
  title,
  desc,
  testId,
  disabled,
  viewMode,
  checked,
  amount,
  error,
  onCheckedChange,
  onAmountChange,
}) => (
  <Box direction="row" gap="spacing12">
    <Box width="medium">
      <FraudThresholdFieldLabel title={title} desc={desc} />
    </Box>
    {viewMode ? (
      <Text data-testid={`${testId}-amount`} color="textBody">
        {checked ? costFormater(Number(amount) || 0) : DEFAULT_EMPTY_CHARACTER}
      </Text>
    ) : (
      <Box width="180px" gap="spacing12">
        <Checkbox
          testId={testId}
          checked={checked}
          disabled={disabled}
          onChange={onCheckedChange}
        />
        {checked && (
          <PriceInput
            name={`${testId}-amount`}
            testId={`${testId}-amount`}
            value={amount}
            placeholder="Enter $ amount"
            disabled={disabled}
            errorText={error}
            onChange={onAmountChange}
          />
        )}
      </Box>
    )}
  </Box>
);

export default FraudThresholdField;
